import { useT } from "../i18n";
import { RichTextEditor } from "./RichTextEditor";

export interface DraftMeasure {
  title: string;
  /** tiptap JSON string for the measure detail ("" = empty). */
  detailDoc: string;
}

/** Editable list of platform measures (plain title + rich detail). */
export function MeasuresEditor({
  value,
  onChange,
}: {
  value: DraftMeasure[];
  onChange: (next: DraftMeasure[]) => void;
}) {
  const t = useT();
  const set = (i: number, patch: Partial<DraftMeasure>) =>
    onChange(value.map((m, j) => (j === i ? { ...m, ...patch } : m)));
  const add = () => onChange([...value, { title: "", detailDoc: "" }]);
  const remove = (i: number) => onChange(value.filter((_, j) => j !== i));

  return (
    <div className="space-y-3">
      {value.map((m, i) => (
        <div key={i} className="border border-border rounded-lg p-3 space-y-2">
          <div className="flex gap-2">
            <input
              className="flex-1 bg-panel2 border border-border rounded px-2 py-1.5 text-sm"
              placeholder={t("measures.titlePlaceholder")}
              maxLength={120}
              value={m.title}
              onChange={(e) => set(i, { title: e.target.value })}
            />
            <button type="button" onClick={() => remove(i)} className="text-muted hover:text-warn text-sm px-2" title={t("common.remove")}>
              ✕
            </button>
          </div>
          <RichTextEditor
            valueDoc={m.detailDoc || null}
            onChange={(detailDoc) => set(i, { detailDoc })}
            ariaLabel={t("measures.detailPlaceholder")}
          />
        </div>
      ))}
      <button type="button" onClick={add} className="text-accent text-sm">
        + {t("measures.add")}
      </button>
    </div>
  );
}
